module.exports = __webpack_public_path__ + "img/service.cefe7947.webp";